import React, { useEffect, useState } from "react"
import { Box, Button, Typography, Textarea, Input } from "@mui/joy"
import { useFormatter } from "src/mtska-frontend-app-component/utils"
import { useTranslation } from "react-i18next"
import { useDrawer } from "../Drawer"
import { Icon } from "../../assets"
import { InputDateControl } from "."
import { useFormContext, useWatch } from "react-hook-form"
import JSONPretty from 'react-json-pretty';

const WidgetActivityEditor = props => {

    const { setValue } = useFormContext();
    const campaignlead = useWatch({
        control: props.control,
        name: 'campaignlead'
    });

    const { t } = useTranslation()

    const [view, setView] = useState("editor")
    const [campaign, setCampaign] = useState()
    const [activityOutcomes, setActivityOutcomes] = useState()
    const [groupedOutcomes, setGroupedOutcomes] = useState()
    const [selected, setSelected] = useState()
    const [notes, setNotes] = useState("")

    useEffect(() => {
        setValue('selected', selected);
    }, [selected]);

    useEffect(() => {
        setValue('notes', notes);
    }, [notes])

    useEffect(() => {
        if (!campaignlead) return;
        setCampaign(campaignlead?.data?.campaign)

        const activityOutcomes = campaignlead?.data?.campaign?.activityOutcomes;
        setActivityOutcomes(activityOutcomes);

        const groupedOutcomes = activityOutcomes.reduce((acc, outcome) => {
            if (!acc[outcome.processStatus]) {
                acc[outcome.processStatus] = [];
            }
            acc[outcome.processStatus].push(outcome);
            return acc;
        }, { ok: [], wip: [], ko: [] });
        setGroupedOutcomes(groupedOutcomes ?? [])
    }, [campaignlead])

    const toggleStyle = {
        borderRadius: 50,
        padding: '10px',
        backgroundColor: "#f2f2f5",
        display: "flex",
        gap: 4,
        justifyContent: "center"
    }

    const toggleBtn = active => ({
        flex: 1,
        borderRadius: 50,
        backgroundColor: active ? "#ffffff" : "transparent",
        color: active ? "#000" : "#555",
        boxShadow: active ? "0 1px 3px rgba(0,0,0,0.15)" : "none",
        ':hover': {
            backgroundColor: active ? "white" : "#e1e1e1",
        }
    })
    console.info(activityOutcomes)
    return (
        <Box className={"form-element form-activity-editor " + props.className}>
            <Box width="100%" display="flex" flexDirection="column" alignItems="center" gap={3} className="form-element">
                <Box sx={toggleStyle} width="90%">
                    <Button sx={toggleBtn(view === "editor")} onClick={() => setView("editor")}>
                        {t("Registra Esito")}
                    </Button>
                    <Button sx={toggleBtn(view === "history")} onClick={() => setView("history")}>
                        {t("Storico Esiti Lead")}
                    </Button>
                </Box>

                {view === "history" && (
                    <Box width="90%" display="flex" flexDirection="column" alignItems="center" gap={2}>
                        {
                            campaign &&
                            <Box width="100%" display="flex" alignItems="center" justifyContent="center" gap={1} bgcolor="#eef5ff" p={1.5} borderRadius="md">
                                <Icon icon={campaign?.mode == 'Walk in' ? 'faHandshake' : 'faTelephone'} />
                                <Typography>{campaign?.mode} | {campaign?.mode == 'Walk in' ? t("Visita") : t("Contatto telefonico")}</Typography>
                            </Box>
                        }
                        <Typography level="title-lg" textAlign="center">{t("Storico dei contatti precedenti")}</Typography>

                        <Box display="flex" flexDirection="column" alignItems="center" gap={2} width="100%">
                            <Box display="flex" flexDirection="column" p={2} borderRadius="md" bgcolor="#e9f8ec" borderLeft="6px solid #14b956" width="100%">
                                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                    <Typography bgcolor="#b8f3c4" px={1.5} py={0.5} borderRadius="lg" fontSize="sm">
                                        {t("Interessato")}
                                    </Typography>
                                </Box>
                                <Typography mt={1} fontSize="sm" textAlign="center">15/01/2025 – 14:30</Typography>
                                <Typography mt={1} fontSize="sm" textAlign="center">
                                    {t("Cliente interessato al servizio, richiede maggiori informazioni sui prezzi.")}
                                </Typography>
                            </Box>

                            <Box display="flex" flexDirection="column" p={2} borderRadius="md" bgcolor="#fff7db" borderLeft="6px solid #f2a900" width="100%">
                                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                    <Typography bgcolor="#ffeaa4" px={1.5} py={0.5} borderRadius="lg" fontSize="sm">
                                        {t("Da richiamare")}
                                    </Typography>
                                </Box>
                                <Typography mt={1} fontSize="sm" textAlign="center">10/01/2025 – 16:15</Typography>
                                <Typography mt={1} fontSize="sm" textAlign="center">
                                    {t("Non disponibile al momento, da ricontattare la prossima settimana.")}
                                </Typography>
                            </Box>

                            <Box display="flex" flexDirection="column" p={2} borderRadius="md" bgcolor="#fff7db" borderLeft="6px solid #f2a900" width="100%">
                                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                    <Typography bgcolor="#ffeaa4" px={1.5} py={0.5} borderRadius="lg" fontSize="sm">
                                        {t("Da richiamare")}
                                    </Typography>
                                </Box>
                                <Typography mt={1} fontSize="sm" textAlign="center">07/09/2024 – 11:24</Typography>
                                <Typography mt={1} fontSize="sm" textAlign="center">
                                    {t("Non reperibile al momento, da ricontattare nei prossimi giorni.")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                )}

                {view === "editor" && (
                    <Box width="90%" display="flex" flexDirection="column" alignItems="center" gap={2}>
                        {
                            campaign &&
                            <Box width="100%" display="flex" alignItems="center" justifyContent="center" gap={1} bgcolor="#eef5ff" p={1.5} borderRadius="md">
                                <Icon icon={campaign?.mode == 'Walk in' ? 'faHandshake' : 'faTelephone'} />
                                <Typography>{campaign?.mode} | {campaign?.mode == 'Walk in' ? t("Visita") : t("Contatto telefonico")}</Typography>
                            </Box>
                        }

                        <Typography level="title-lg" textAlign="center" mt={2}>{t("Registra esito contatto")}</Typography>

                        {
                            groupedOutcomes && Object.entries(groupedOutcomes).map(([status, items]) => {
                                return (
                                    <>
                                        <Typography level="title-sm" textAlign="center" mt={0}>{t('outcome-'+status)}</Typography>
                                        <Box className="outcome-wrapper" width="100%" display="flex" alignItems="center" justifyContent="center" gap={1} border={1} borderColor="#f2f2f2ff" p={3} m={2} mt={0} borderRadius="md">

                                            {
                                                items && items.map(
                                                    activityOutcome => <>
                                                        <Button
                                                            className="outcome-option"
                                                            variant={selected === activityOutcome.id ? "solid" : "outlined"}
                                                            color={activityOutcome.processStatus === 'ok' ? "success" : activityOutcome.processStatus === 'ko' ? "danger" : "warning"}
                                                            onClick={() => setSelected(activityOutcome.id)}
                                                            startDecorator={<Icon icon={activityOutcome.processStatus === 'ok' ? "faThumbsUp" : activityOutcome.processStatus === 'ko' ? "faThumbsDown" : "faClock"} />}
                                                        >
                                                            {activityOutcome.name}
                                                        </Button>
                                                    </>
                                                )
                                            }
                                        </Box>
                                    </>
                                )
                            })
                        }


                        <Box width="100%" display="flex" flexDirection="column" alignItems="center" gap={1}>
                            <Typography level="title-lg" textAlign="center">{t("Note libere")}</Typography>
                            <Textarea
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                placeholder={t("Inserisci qui eventuali note aggiuntive sul contatto...")}
                                minRows={4}
                                sx={{
                                    width: "100%",
                                    backgroundColor: "#f8f9fa",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "md"
                                }}
                            />
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default WidgetActivityEditor